import { render, staticRenderFns } from "./IdConversion.vue?vue&type=template&id=6aef2872"
import script from "./IdConversion.vue?vue&type=script&lang=js"
export * from "./IdConversion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports